import styles from "./LoadingOverlay.module.css";
import { ReactComponent as TravelIcon } from "../../../assets/icons/eliteVacances.svg";
/**
 * Componente LoadingOverlay
 * Muestra un overlay de carga con spinner y mensaje
 *
 * @param {Object} props
 * @param {string} props.message - Mensaje principal
 * @param {string} props.subtitle - Mensaje secundario
 */
const LoadingOverlay = ({
  message = "Estamos procesando tu solicitud...",
  subtitle = "Por favor, no cierres esta ventana.",
}) => {
  return (
    <div
      className={styles["loading-overlay"]}
      role="alert"
      aria-busy="true"
      aria-live="assertive"
    >
      {/* Spinner */}
      <div className={styles["spinner-container"]}>
        <div className={styles["spinner-ring-outer"]}></div>
        <div className={styles["spinner-ring"]}></div>
        <span className={styles["spinner-icon"]}>
          <TravelIcon width={200}/>
        </span>
      </div>

      {/* Texto */}
      <h4 className={styles["loading-title"]}>{message}</h4>
      <p className={styles["loading-subtitle"]}>{subtitle}</p>
    </div>
  );
};

export default LoadingOverlay;
